module.exports = "/assets/js/f92024da10d4598d321b68bf07fcc470.svg";